import { Injectable, signal } from '@angular/core';

export interface ForceSubmitContext {
    eventId: string;
    eventTitle: string;
    registrationId: string;
    slotId?: number;
    slotLabel: string;
}

/**
 * Carries "the user is choosing an existing force to submit to this event slot" from the event
 * detail page's Select List button, through the force list, into the force detail page's Submit
 * button — a root-scoped signal rather than a query param, since this spans a normal "browse to
 * a force" navigation that would otherwise be indistinguishable from just looking at a force.
 * Not auto-cleared on read (unlike ForceCreationContextService) because more than one page needs
 * to see it across this multi-step flow; cleared explicitly on a successful submit, and
 * defensively by the event detail page on its own load so a stale, abandoned attempt from
 * earlier never leaks into an unrelated later visit.
 */
@Injectable({ providedIn: 'root' })
export class ForceSubmitContextService {
    private readonly _context = signal<ForceSubmitContext | null>(null);
    readonly context = this._context.asReadonly();

    set(context: ForceSubmitContext) {
        this._context.set(context);
    }

    clear() {
        this._context.set(null);
    }
}
